module.exports = __webpack_public_path__ + "static/Bundle4VinylClear-6dc65c750f426ebaff064ffbfae88adb.png";